export const WaitingStatus = {
  all: '全て',
  without: '引き継ぎ以外',
  only: '引き継ぎのみ'
} as const;

export type WaitingStatusKey = keyof typeof WaitingStatus;

export const WaitingStatusKeys: readonly WaitingStatusKey[] = ['all', 'without', 'only'];
